export const SUPER_ADMIN = "SUPER_ADMIN";
export const ADMIN = "ADMIN";
export const USER_ROLES = {
  ADMIN: 1,
  USER: 2
}
